/***************************************************/
/****** CUSTOM SCRIPT FOR BELT SELECTION PAGE ******/
/***************************************************/

/* Associated to template/product.belt-selection.liquid */

// ---------------------------
// ----- HTML References -----
// ---------------------------
const { qs, qsa } = window.BeltCustomizerCore;
const canvasBelt = document.getElementById("canvas-belt");
const canvasWorn = document.getElementById("canvas-worn");
const options = qsa('.option');

// ----------------------------
// ----- Constant sources -----
// ----------------------------
const pantsSrc = "https://cdn.shopify.com/s/files/1/0894/4094/4465/files/1400px-base-pantalon.jpg?v=1762936339";

// -----------------------
// ----- Canvas size -----
// -----------------------

function fitToContainer(canvas) {
  window.BeltCustomizerCore.fitCanvas(canvas);
}

function initCanvas() {
  const canvasList = [canvasBelt, canvasWorn];

  const observer = new ResizeObserver(() => {
    canvasList.forEach(c => fitToContainer(c));
    renderPreview(previewState);
  });

  canvasList.forEach(c => observer.observe(c.parentElement));
}

// ------------------------
// ------- Tooltips -------
// ------------------------

function initTooltips() {
  const tooltip = document.getElementById('tooltip-global');

  qsa('.tooltip-wrapper').forEach(wrapper => {
    wrapper.addEventListener('mouseenter', () => {
      const content = wrapper.querySelector('.tooltip-content').innerHTML;
      const rect = wrapper.getBoundingClientRect();

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

      tooltip.innerHTML = content;
      tooltip.style.top = `0px`;
      tooltip.style.display = 'block';
      tooltip.style.opacity = '0';

      const halfWidth = tooltip.offsetWidth / 2;
      const center = rect.left + rect.width / 2;
      const visibleCenter = Math.max(halfWidth + 12,
        Math.min(center, window.innerWidth - halfWidth - 12));
      tooltip.style.left = `${visibleCenter + scrollLeft}px`;

      requestAnimationFrame(() => {
        const tooltipHeight = tooltip.offsetHeight;
        tooltip.style.top = `${rect.top + scrollTop - tooltipHeight - 10}px`;
        tooltip.style.opacity = '1';
      });
    });

    wrapper.addEventListener('mouseleave', () => {
      tooltip.style.display = 'none';
      tooltip.style.opacity = '0';
    });
  });
}

// ------------------------
// -------- Modals --------
// ------------------------

function initModals() {
  const openBtns = qsa(".open-modal");

  openBtns.forEach(function(openBtn) {
    openBtn.addEventListener("click", () => {
      const modal = qs(openBtn.dataset.src);
      const closeBtn = modal.querySelector(".custom-modal__close");
      const overlay = modal.querySelector(".custom-modal__overlay");

      modal.style.display = "block";

      closeBtn.addEventListener("click", () => {
        modal.style.display = "none";
      });

      overlay.addEventListener("click", () => {
        modal.style.display = "none";
      });
    });
  });
}

// -----------------------------------
// ----- Asynchronous image loader ----
// -----------------------------------

const imageCache = new Map();

function loadImage(src) {
  if (src.startsWith('//')) src = 'https:' + src;
  if (imageCache.has(src)) return imageCache.get(src);

  const request = new Promise((resolve, reject) => {

    const img = new Image();
    img.crossOrigin = "anonymous";

    img.onload = () => {
      resolve(img);
    };

    img.onerror = () => {
      console.error('Failed to load:', src);
      imageCache.delete(src);
      reject(new Error(`Failed to load ${src}`));
    };

    img.src = src;
  });

  imageCache.set(src, request);
  return request;
}

// -----------------------------
// ----- Preview rendering -----
// -----------------------------

let previewState = {
  leather: "Bulf-Calf / Navy & ebony",
  face: "recto",
  buckle: "JH / Palladium",
  initials: false,
  initialsColor: "neutral",
  initialsLetters: null,
  initialsPosition: "visible",
  initialsPoints: "With points",
};

function drawScaled(ctx, img, canvas) {
  ctx.drawImage(
    img,
    0,
    0,
    img.width,
    img.height,
    0,
    0,
    canvas.width,
    canvas.height
  );
}

function initPreviewState() {
  const leather_category = qs('#step-leather .option.active').dataset.leatherCategory;
  const leather_name = qs('#step-leather .option.active').dataset.leatherName;
  const buckle_category = qs('#step-buckle .option.active').dataset.buckleCategory;
  const buckle_name = qs('#step-buckle .option.active').dataset.buckleName;
  const face = qs('.rectoverso div.active').dataset.face;

  previewState.leather = leather_category + ' / ' + leather_name;
  previewState.buckle = qs('#step-buckle .option.active').dataset.configNone === 'true'
    ? null : buckle_category + ' / ' + buckle_name;
  previewState.face = face;
}

let previewRequestId = 0;

async function renderPreview(state) {
  const requestId = ++previewRequestId;
  canvasBelt.style.opacity = 0.3;
  canvasWorn.style.opacity = 0.3;

  if (typeof state.leather === 'undefined' || typeof state.face === 'undefined') {
    return;
  }

  const buckleSources = state.buckle ? window.overlays.buckles[state.buckle] : null;
  const [leather, leather_worn, buckle, buckle_worn, model, shadow] = await Promise.all([
    loadImage(window.overlays.leathers[state.leather][state.face]),
    loadImage(window.overlays.leathers[state.leather]["worn_" + state.face]),
    buckleSources ? loadImage(buckleSources.alone) : Promise.resolve(null),
    buckleSources ? loadImage(buckleSources.worn) : Promise.resolve(null),
    loadImage(window.overlays.model),
    loadImage(window.overlays.shadow_belt)
  ]);

  if (requestId !== previewRequestId) return;

  const ctxBelt = canvasBelt.getContext("2d");
  ctxBelt.clearRect(0, 0, canvasBelt.width, canvasBelt.height);
  drawScaled(ctxBelt, shadow, canvasBelt);
  drawScaled(ctxBelt, leather, canvasBelt);

  if (state.buckle) {
    drawScaled(ctxBelt, buckle, canvasBelt);
  }

  const ctxWorn = canvasWorn.getContext("2d");
  ctxWorn.clearRect(0, 0, canvasWorn.width, canvasWorn.height);
  ctxWorn.drawImage(model, 0, 0, canvasWorn.width, canvasWorn.height);
  ctxWorn.drawImage(leather_worn, 0, 0, canvasWorn.width, canvasWorn.height);

  if (state.buckle) {
    ctxWorn.drawImage(buckle_worn, 0, 0, canvasWorn.width, canvasWorn.height);
  }

  const angles = {
    belt: {
      visible: [
        Math.tan(-4 * Math.PI / 180),
        Math.tan(6 * Math.PI / 180),
        6 * Math.PI / 180,
      ],
      hidden: [
        Math.tan(30 * Math.PI / 180),
        Math.tan(-35 * Math.PI / 180),
        10 * Math.PI / 180,
      ],
    },
    worn: {
      visible: [
        Math.tan(-2 * Math.PI / 180),
        Math.tan(3 * Math.PI / 180),
        2 * Math.PI / 180,
      ],
    },
  };

  const size_ratios = {
    belt: {
      visible: 0.045,
      hidden: 0.043,
    },
    worn: {
      visible: 0.032,
    },
  };

  const position_ratios = {
    belt: {
      visible: [0.20, 0.66],
      hidden: [0.64, 0.47],
    },
    worn: {
      visible: [0.34, 0.56],
    },
  };

  const drawInitials = async (
    ctx,
    canvas,
    angles,
    size_ratio,
    position_ratio,
    bg_image_url = null
  ) => {
    const fontSize = canvas.width * size_ratio;
    const x = Math.round(canvas.width * position_ratio[0]);
    const y = Math.round(canvas.height * position_ratio[1]);

    ctx.save();

    ctx.translate(x, y);
    ctx.rotate(angles[2]);
    ctx.transform(1, angles[1], angles[0], 1, 0, 0);

    ctx.font = `${fontSize}px serif`;
    ctx.textBaseline = 'middle';

    let initialsText = state.initialsLetters;

    if (
      state.initialsPoints.includes('With points') ||
      state.initialsPoints.includes('Avec')
    ) {
      initialsText = initialsText.split('').join('.') + '.';
    }

    if (bg_image_url) {
      try {
        const bg = await loadImage('https:' + bg_image_url);
        const pattern = ctx.createPattern(bg, 'repeat');
        ctx.fillStyle = pattern;
        ctx.fillText(initialsText, 0, 0);
      } catch (err) {
        console.warn("Pattern image failed to load:", 'https:' + bg_image_url);
      }
    } else {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
      ctx.fillText(initialsText, 0, 0);
    }

    ctx.restore();
  };

  if (state.initials && state.initialsLetters && state.face === 'recto') {
    const bg_image_url = qs('#initials-details .initials-color .option.active').dataset.bgImage;

    if (state.initialsPosition.toLowerCase().includes('visible')) {
      drawInitials(
        ctxBelt,
        canvasBelt,
        angles.belt.visible,
        size_ratios.belt.visible,
        position_ratios.belt.visible,
        bg_image_url
      );

      drawInitials(
        ctxWorn,
        canvasWorn,
        angles.worn.visible,
        size_ratios.worn.visible,
        position_ratios.worn.visible,
        bg_image_url
      );
    } else {
      drawInitials(
        ctxBelt,
        canvasBelt,
        angles.belt.hidden,
        size_ratios.belt.hidden,
        position_ratios.belt.hidden,
        bg_image_url
      );
    }
  }

  canvasBelt.style.opacity = 1;
  canvasWorn.style.opacity = 1;
}

// -------------------------
// ----- Step selector -----
// -------------------------

const mandatorySteps = [1, 2];

let currentStepIndex = 0;
let isTransitioning = false;
let queuedStepNavigation = null;

const recapItems = qsa('.recap-item');
const stepElements = Array.from(qsa('.step'));
const stepsCount = stepElements.length;

const visitedSteps = new Set();
visitedSteps.add(0);

const stepTitleElements = Array.from(document.querySelectorAll('.step-title-nav'));

function navigateToStep(nextIndex, direction) {
  if (nextIndex < 0 || nextIndex >= stepsCount) {
    return false;
  }

  if (isTransitioning) {
    if (nextIndex !== currentStepIndex) {
      queuedStepNavigation = { nextIndex, direction };
    }
    return false;
  }

  if (nextIndex === currentStepIndex) return false;

  currentStepIndex = nextIndex;
  updateStepDisplay(direction);
  return true;
}

function updateStepNavigationUI() {
  stepTitleElements.forEach((el, index) => {
    const wrapper = el.closest('.step-title-wrapper');

    el.classList.toggle('active', index === currentStepIndex);
    wrapper.classList.toggle('active', index === currentStepIndex);
  });

  if (window.matchMedia('(max-width: 768px)').matches) {
    BeltCustomizerCore.centerMobileStepNavigation();
    return;
  }

  const container = document.querySelector('.step-nav-titles');
  const el = stepTitleElements[currentStepIndex];

  const elRect = el.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  const offset =
    (elRect.left + elRect.width / 2) -
    (containerRect.left + containerRect.width / 2);

  container.style.transform = `translateX(${-offset}px)`;
}

stepTitleElements.forEach((el, i) => {
  el.addEventListener('click', () => {
    navigateToStep(i, i > currentStepIndex ? 'next' : 'prev');
  });
});

function initArrowClickHandlers() {
  qsa('.nav-arrow').forEach(arrow => {
    arrow.removeEventListener('click', handleArrowClick);
    arrow.addEventListener('click', handleArrowClick);
  });
}

function handleArrowClick(e) {
  e.stopPropagation();

  const dir = e.currentTarget.dataset.dir;

  if (dir === 'prev') navigateToStep(currentStepIndex - 1, 'prev');
  if (dir === 'next') navigateToStep(currentStepIndex + 1, 'next');
}


// ------------------------
// ----- Scroll hints -----
// ------------------------

const SCROLL_HINT_BOTTOM_THRESHOLD = 40;
let scrollHintResizeObserver = null;

function updateScrollHintForRow(row) {
  const step = row.closest('.step');

  if (!step) return;

  const hasScrollableContent = row.scrollHeight > row.clientHeight + 2;

  const isNearBottom =
    row.scrollTop + row.clientHeight >=
    row.scrollHeight - SCROLL_HINT_BOTTOM_THRESHOLD;

  step.classList.toggle(
    'hide-scroll-hint',
    !hasScrollableContent || isNearBottom
  );
}

function updateScrollHints() {
  qsa('.step-row').forEach(updateScrollHintForRow);
}

function initScrollHints() {
  const rows = Array.from(qsa('.step-row'));

  rows.forEach(row => {
    updateScrollHintForRow(row);

    if (row.dataset.scrollHintBound === 'true') return;

    row.dataset.scrollHintBound = 'true';

    row.addEventListener(
      'scroll',
      () => updateScrollHintForRow(row),
      { passive: true }
    );
  });

  if ('ResizeObserver' in window && !scrollHintResizeObserver) {
    scrollHintResizeObserver = new ResizeObserver(updateScrollHints);

    rows.forEach(row => {
      scrollHintResizeObserver.observe(row);
    });
  }

  window.addEventListener('resize', updateScrollHints, { passive: true });
}

// -----------------------------
// ----- Touch step swipes ------
// -----------------------------

function initStepSwipeNavigation() {
  BeltCustomizerCore.initStepSwipeNavigation(qs('#controls-container'), direction => {
    navigateToStep(
      currentStepIndex + (direction === 'next' ? 1 : -1),
      direction
    );
  });
}

function firstMissingMandatoryStep() {
  for (const i of mandatorySteps) {
    if (!visitedSteps.has(i)) return i;
  }

  return null;
}

function focusInitialsLettersWhenReady(attempt = 0) {
  const initialsStep = qs('#step-initials');
  const initialsInput = qs('#initials-details .initials-letters input');

  if (!initialsStep || !initialsInput) return;

  if (isTransitioning || !initialsStep.classList.contains('active')) {
    if (attempt < 30) {
      setTimeout(() => focusInitialsLettersWhenReady(attempt + 1), 60);
    }
    return;
  }

  initialsInput.focus({ preventScroll: true });
  initialsInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
  initialsInput.reportValidity();
}

function validateBeforeSubmit(e) {
  const missingMandatory = firstMissingMandatoryStep();

  if (missingMandatory !== null) {
    e.preventDefault();

    const dir = missingMandatory > currentStepIndex ? 'next' : 'prev';
    navigateToStep(missingMandatory, dir);

    return true;
  }

  const selectedSize = qs('#step-size .option.active');
  if (!selectedSize || selectedSize.classList.contains('oos')) {
    e.preventDefault();
    const sizeStepIndex = stepElements.indexOf(qs('#step-size'));
    navigateToStep(sizeStepIndex, sizeStepIndex > currentStepIndex ? 'next' : 'prev');
    return true;
  }

  const initialsToggle = qs('#toggle-initials');
  const initialsInput = qs('#initials-details .initials-letters input');
  const initialsInvalid = initialsToggle?.checked && (
    !initialsInput ||
    initialsInput.value.trim() === '' ||
    !initialsInput.checkValidity()
  );

  if (initialsInvalid) {
    e.preventDefault();

    const initialsStepIndex = stepElements.indexOf(qs('#step-initials'));
    const dir = initialsStepIndex > currentStepIndex ? 'next' : 'prev';

    navigateToStep(initialsStepIndex, dir);
    focusInitialsLettersWhenReady();

    return true;
  }

  return false;
}

qs('#recap-buy').addEventListener('click', validateBeforeSubmit);
qs('form[action*="/cart/add"]').addEventListener('submit', validateBeforeSubmit);

function updateStepDisplay(direction = 'next') {
  if (isTransitioning) return;

  const allSteps = Array.from(qsa('.step'));
  const activeStep = allSteps.find(el => el.classList.contains('active'));
  const newStep = allSteps[currentStepIndex];

  if (!newStep || newStep === activeStep) {
    return;
  }

  isTransitioning = true;
  visitedSteps.add(currentStepIndex);

  allSteps.forEach(el => {
    el.classList.remove('slide-out-left', 'slide-out-right');
  });

  const isNext = direction === 'next';

  newStep.classList.add('active');

  requestAnimationFrame(updateScrollHints);

  newStep.style.transition = 'none';
  newStep.style.transform = isNext ? 'translateX(100%)' : 'translateX(-100%)';
  newStep.style.opacity = '1';
  newStep.style.zIndex = '2';

  void newStep.offsetWidth;

  if (activeStep) {
    activeStep.style.transition = 'transform 0.5s ease, opacity 0.5s ease';
    activeStep.style.zIndex = '1';
    activeStep.style.transform = isNext ? 'translateX(-100%)' : 'translateX(100%)';
  }

  newStep.style.transition = 'transform 0.5s ease';
  newStep.style.transform = 'translateX(0)';

  setTimeout(() => {
    if (activeStep) activeStep.classList.remove('active');

    newStep.removeAttribute('style');

    updateScrollHints();

    isTransitioning = false;

    if (queuedStepNavigation) {
      const queued = queuedStepNavigation;
      queuedStepNavigation = null;
      navigateToStep(queued.nextIndex, queued.direction);
    }
  }, 500);

  recapItems.forEach((r, i) => {
    r.classList.toggle('active', i === currentStepIndex);
  });

  updateStepNavigationUI();
}

recapItems.forEach((item, i) => {
  item.addEventListener('click', () => {
    navigateToStep(i, i > currentStepIndex ? 'next' : 'prev');
  });
});

// ----------------------------
// ----- Recap bottom bar -----
// ----------------------------

function updateRecap(key, value) {
  const el = document.getElementById(
    `recap${key.charAt(0).toUpperCase() + key.slice(1)}`
  );

  if (el) el.textContent = value;
}

function initRecap() {
  const active_leather = qs('#step-leather .option.active');
  const active_buckle = qs('#step-buckle .option.active');
  const active_size = qs('#step-size .option.active');
  const active_unit = qs('#step-size .unit-option.active');

  if (!active_leather || !active_buckle || !active_size) return;

  updateRecap('leather', active_leather.dataset.leatherName);
  updateRecap('buckle', active_buckle.dataset.buckleName);

  let unit = active_unit.dataset.unit;
  let size = active_size.dataset.size;

  if (unit === 'in') {
    size = active_size.dataset.inches;
  }

  const size_disp = size + unit;

  updateRecap('size', size_disp);
}

function updatePrice() {
  const active_leather = qs('#step-leather .option.active') || qs('#step-leather .option:not(.oos)');
  const active_buckle = qs('#step-buckle .option.active') || qs('#step-buckle .option:not(.oos)');
  const active_initials = qs('#step-initials #toggle-initials');
  const price_span = qsa('#recap-bar .recap-price .amount');

  if (!active_leather || !active_buckle || !active_initials) return false;
  active_leather.classList.add('active');
  active_buckle.classList.add('active');

  let price = Math.round(
    (parseInt(active_leather.dataset.price) +
      parseInt(active_buckle.dataset.price)) / 100
  );

  if (active_initials.checked) {
    price = price + parseInt(active_initials.dataset.price) / 100;
  }

  if (!Number.isFinite(price)) return false;

  price_span.forEach(elem => {
    elem.textContent = price;
  });

  return true;
}

// -------------------------------------
// ----- Default options selection -----
// -------------------------------------

function selectDefaultOptions() {
  const leather_options = qsa('#step-leather .option');

  leather_options.forEach(s => s.classList.remove('active'));

  const firstLeatherAvailable = Array.from(leather_options).find(
    opt => !opt.classList.contains('oos')
  );

  firstLeatherAvailable.classList.add('active');

  const buckle_options = qsa('#step-buckle .option');

  buckle_options.forEach(s => s.classList.remove('active'));

  const firstBuckleAvailable = Array.from(buckle_options).find(
    opt => !opt.classList.contains('oos')
  );

  firstBuckleAvailable.classList.add('active');
}

// ------------------------------------
// ----- Size availability update -----
// ------------------------------------

function updateSizeAvailability() {
  const selectedLeather = qs('#step-leather .option.active');
  if (!selectedLeather) return;
  const availableSizes = new Set((selectedLeather.dataset.availableSizes || '')
    .split(',').map(size => size.trim()).filter(Boolean));

  const sizeButtons = qsa('#size-options .option');
  let firstAvailableBtn = null;
  let currentSelected = document.querySelector('#size-options .option.active');

  sizeButtons.forEach(btn => {
    const size = btn.dataset.size;
    if (!availableSizes.has(size)) {
      btn.classList.add('oos');
      btn.classList.remove('active');
      btn.setAttribute('aria-label', `${size} ${btn.dataset.unavailableLabel}`);
    } else {
      btn.classList.remove('oos');
      btn.setAttribute('aria-label', size);

      if (!firstAvailableBtn) {
        firstAvailableBtn = btn;
      }
    }
  });

  if (!currentSelected || currentSelected.classList.contains('oos')) {
    if (firstAvailableBtn) {
      firstAvailableBtn.classList.add('active');
    }
  }

  const active_size = qs('#step-size .option.active');
  const active_unit = qs('#step-size .unit-option.active');

  if (!active_size || !active_unit) return;
  let unit = active_unit.dataset.unit;
  let size = active_size.dataset.size;

  if (unit === 'in') {
    size = active_size.dataset.inches;
  }

  const size_disp = size + unit;

  updateRecap('size', size_disp);
}

// -----------------------------------------------------------
// ----- Handle active/inactive options and update recap -----
// -----------------------------------------------------------

options.forEach(opt => {
  opt.addEventListener('click', () => {
    if (opt.classList.contains('oos')) return;
    const siblings = opt.closest('.exclusive-options').querySelectorAll('.option');

    siblings.forEach(s => s.classList.remove('active'));

    opt.classList.add('active');
  });
});

qsa('.option[data-leather-name]').forEach(opt => {
  opt.addEventListener('click', () => {
    updateRecap('leather', opt.dataset.leatherName);
    updateSizeAvailability();

    previewState.leather =
      opt.dataset.leatherCategory + ' / ' + opt.dataset.leatherName;

    renderPreview(previewState);
  });
});

qsa('.option[data-buckle-name]').forEach(opt => {
  opt.addEventListener('click', () => {
    updateRecap('buckle', opt.dataset.buckleName);

    if (opt.dataset.configNone !== 'true' && opt.dataset.buckleName !== 'Without' && opt.dataset.buckleName !== 'Sans') {
      previewState.buckle =
        opt.dataset.buckleCategory + ' / ' + opt.dataset.buckleName;
    } else {
      previewState.buckle = null;
    }

    renderPreview(previewState);
  });
});

qsa('.option[data-size]').forEach(opt => {
  opt.addEventListener('click', () => {
    if (opt.classList.contains('oos')) return;
    const unit = qs('.unit-option.active').dataset.unit;

    let size = opt.dataset.size;

    if (unit === 'in') {
      size = Math.round(size / 2.54 * 10) / 10;
    }

    const size_disp = size + unit;

    updateRecap('size', size_disp);
  });
});

qsa('.unit-option').forEach(opt => {
  opt.addEventListener('click', () => {
    const siblings = opt.closest('.unit-selector').querySelectorAll('.unit-option');

    siblings.forEach(s => s.classList.remove('active'));

    opt.classList.add('active');

    const unit = qs('.unit-option.active').dataset.unit;
    const selectedSizeOption = qs('#step-size .option.active');
    if (!selectedSizeOption) return;
    const selected_opt = selectedSizeOption.dataset.size;

    let size = selected_opt;

    if (unit === 'in') {
      size = Math.round(size / 2.54 * 10) / 10;
    }

    const size_disp = size + unit;

    updateRecap('size', size_disp);

    qsa('#size-options .option').forEach(sizeOpt => {
      if (unit === 'in') {
        sizeOpt.querySelector('.size-option__value').textContent = sizeOpt.dataset.inches;
      } else if (unit === 'cm') {
        sizeOpt.querySelector('.size-option__value').textContent = sizeOpt.dataset.size;
      }
    });
  });
});

// --------------------------
// ----- Initials state -----
// --------------------------

const updateInitialsState = () => {
  const toggle = qs('#toggle-initials');
  const initialsLetters = qs('#initials-details .initials-letters input');
  const initialsColor = qs('#initials-details .initials-color .option.active');
  const initialsPosition = qs('#initials-details .initials-position .option.active');
  const initialsPoints = qs('#initials-details .initials-points select');

  previewState.initials = toggle.checked;
  previewState.initialsLetters = toggle.checked
    ? initialsLetters.value.toUpperCase().slice(0, 3)
    : null;
  previewState.initialsColor = initialsColor.dataset.color.toLowerCase();
  previewState.initialsPosition = initialsPosition.dataset.position;
  previewState.initialsPoints = initialsPoints.value;

  renderPreview(previewState);

  let initials_disp = '—';

  if (toggle.checked && previewState.initialsLetters) {
    initials_disp = previewState.initialsLetters;

    if (previewState.initialsPoints) {
      initials_disp = initials_disp.split('').join('.') + '.';
    }
  }

  updateRecap('initials', initials_disp);
  updateBundleSelection();
};

function initInitialsPreviewHandlers() {
  qs('#toggle-initials').addEventListener('change', updateInitialsState);

  qs('#initials-details .initials-letters input').addEventListener(
    'input',
    updateInitialsState
  );

  qsa('#initials-details .initials-color .option').forEach(opt => {
    opt.addEventListener('click', updateInitialsState);
  });

  qsa('#initials-details .initials-position .option').forEach(opt => {
    opt.addEventListener('click', updateInitialsState);
  });

  qs('#initials-details .initials-points select').addEventListener(
    'input',
    updateInitialsState
  );

  qs('#initials-details .initials-letters input').addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });
}

function markLeatherColorOOS() {
  const leatherOptions = qsa('.leather-row .option');
  leatherOptions.forEach(leatherOption => {
    const anyInStock = Boolean(leatherOption.dataset.availableSizes?.trim());

    if (!anyInStock) {
      leatherOption.classList.add('oos');
    } else {
      leatherOption.classList.remove('oos');
    }
  });

  const selectedLeather = qs('#step-leather .option.active');
  if (selectedLeather?.classList.contains('oos')) {
    selectedLeather.classList.remove('active');
    leatherOptions.find(option => !option.classList.contains('oos'))?.classList.add('active');
    updatePrice();
  }
}

// ------------------------------------------
// ----- Form / Bundle selection update -----
// ------------------------------------------

function updateBundleSelection() {
  const active_leather = qs('#step-leather .option.active');
  const active_buckle = qs('#step-buckle .option.active');
  const active_size = qs('#step-size .option.active');

  const active_initials = qs('#step-initials #toggle-initials');
  const initials_points = qs('#step-initials .initials-points select');
  const initials_color = qs('#step-initials .initials-color .option.active');
  const initials_position = qs('#step-initials .initials-position .option.active');
  const initials_letters = qs('#step-initials .initials-letters input');

  if (!active_leather || !active_buckle || !active_size || active_size.classList.contains('oos')) return false;

  const input_bundle_selection = qs("input[name='properties[_bundle_selection]']");
  const initials_enabled = Boolean(active_initials?.checked);
  const initials_color_value = initials_color?.dataset.color || 'silver';
  const initials_position_value = initials_position?.dataset.position || '';
  const initials_points_value = initials_points?.value || '';
  const initials_letters_value = (initials_letters?.value || '').toUpperCase();

  const initials_prefix = 'Initials - ';
  const initials_value =
    initials_prefix +
    initials_color_value +
    ' / ' +
    initials_position_value +
    ' / ' +
    initials_points_value;

  if (input_bundle_selection) {
    input_bundle_selection.value =
      (active_leather.dataset.variantName || '') +
      ' / ' +
      (active_size.dataset.size || '') +
      ' <> ' +
      (active_buckle.dataset.variantName || '');

    if (initials_enabled) {
      input_bundle_selection.value =
        input_bundle_selection.value + ' <> ' + initials_value;
    }
  }

  const setCartProperty = (key, value) => {
    const input = qs(`[data-cart-property="${key}"]`);
    if (input) input.value = value || '';
  };

  setCartProperty('leather', active_leather.dataset.variantName || `${active_leather.dataset.leatherCategory} / ${active_leather.dataset.leatherName}`);
  setCartProperty('buckle', active_buckle.dataset.variantName || `${active_buckle.dataset.buckleCategory} / ${active_buckle.dataset.buckleName}`);
  setCartProperty('size', `${active_size.dataset.size} cm`);
  setCartProperty(
    'initials',
    initials_enabled
      ? `${initials_letters_value} / ${initials_color_value} / ${initials_position_value} / ${initials_points_value}`
      : ''
  );

  const leather_key = `${active_leather.dataset.leatherCategory} / ${active_leather.dataset.leatherName}`;
  const buckle_key = `${active_buckle.dataset.buckleCategory} / ${active_buckle.dataset.buckleName}`;
  const initials_position_key = initials_position_value.toLowerCase().includes('visible') ? 'visible' : 'hidden';
  const initials_with_points = initials_points_value.includes('With points') || initials_points_value.includes('Avec');

  BeltCustomizerCore.syncCartPreview({
    root: qs('#customizer'),
    mode: 'selection',
    layers: [
      window.overlays?.shadow_belt,
      window.overlays?.leathers?.[leather_key]?.recto,
      window.overlays?.buckles?.[buckle_key]?.alone
    ],
    initials: {
      letters: initials_enabled ? initials_letters_value : '',
      withPoints: initials_enabled && initials_with_points,
      position: initials_enabled ? initials_position_key : '',
      texture: initials_enabled ? (initials_color?.dataset.bgImage || '') : ''
    }
  });

  return true;
}

qsa('.option').forEach(opt => {
  opt.addEventListener('click', () => {
    updatePrice();
    updateBundleSelection();
  });
});

const selectionProductForm = qs('#customizer form[action*="/cart/add"]');
if (selectionProductForm) {
  selectionProductForm.addEventListener('submit', updateBundleSelection, { capture: true });
  BeltCustomizerCore.bindCartSubmit({
    form: selectionProductForm,
    root: qs('#customizer'),
    beforeSubmit: validateBeforeSubmit,
    syncProperties: updateBundleSelection
  });
}

// -----------------------------
// ----- Recto/verso toggle -----
// -----------------------------

qsa('.rectoverso div').forEach(btn => {
  btn.addEventListener('click', () => {
    const face = btn.dataset.face;

    previewState.face = face;

    qsa('.rectoverso div').forEach(div => {
      div.classList.remove('active');
    });

    btn.classList.add('active');

    renderPreview(previewState);
  });
});

// ------------------------------
// ----- Mobile preview view -----
// ------------------------------

qsa('.beltworn div').forEach(btn => {
  btn.addEventListener('click', () => {
    const preview = btn.dataset.preview;

    qsa('.beltworn div').forEach(div => {
      div.classList.remove('active');
    });

    btn.classList.add('active');

    qsa('.preview-wrapper').forEach(div => {
      div.classList.remove('active');
    });

    qs('#preview-' + preview).classList.add('active');
  });
});

// ------------------
// ----- Init -------
// ------------------

let beltSelectionInitialized = false;

function runSelectionInitTask(name, task) {
  try {
    task();
  } catch (error) {
    console.error(`Belt selection initialization failed at: ${name}`, error);
  }
}

function initBeltSelection() {
  if (beltSelectionInitialized || !qs('#customizer')) return;
  beltSelectionInitialized = true;

  /* Critical UI is initialized first and cannot be blocked by preview data. */
  runSelectionInitTask('first step', () => {
    stepElements.forEach((step, index) => step.classList.toggle('active', index === 0));
    currentStepIndex = 0;
    updateStepNavigationUI();
  });
  runSelectionInitTask('arrow navigation', initArrowClickHandlers);
  runSelectionInitTask('step swipe', initStepSwipeNavigation);
  runSelectionInitTask('step display', () => updateStepDisplay());
  runSelectionInitTask('default options', selectDefaultOptions);
  runSelectionInitTask('default initials color', () => BeltCustomizerCore.selectDefaultInitialsColor(qs('#customizer')));
  runSelectionInitTask('initial price', updatePrice);
  runSelectionInitTask('modals', initModals);
  runSelectionInitTask('initials handlers', initInitialsPreviewHandlers);

  runSelectionInitTask('canvas', () => {
    initCanvas();
    fitToContainer(canvasBelt);
    fitToContainer(canvasWorn);
  });
  runSelectionInitTask('inventory marks', markLeatherColorOOS);
  runSelectionInitTask('size availability', updateSizeAvailability);
  runSelectionInitTask('preview state', initPreviewState);
  runSelectionInitTask('bundle selection', updateBundleSelection);
  runSelectionInitTask('preview render', () => renderPreview(previewState));
  runSelectionInitTask('recap', initRecap);
  runSelectionInitTask('tooltips', initTooltips);
  runSelectionInitTask('scroll hints', initScrollHints);
  runSelectionInitTask('buckle horizontal scroll hint', () => {
    BeltCustomizerCore.initHorizontalScrollHint(qs('#customizer'));
  });

  runSelectionInitTask('initials visibility', () => {
    const toggle = qs('#toggle-initials');
    const details = qs('#initials-details');
    const letters = details && qs('.initials-letters input', details);
    if (!toggle || !details || !letters) return;
    toggle.addEventListener('change', () => {
      details.classList.toggle('hidden', !toggle.checked);
      letters.required = toggle.checked;
      updateBundleSelection();
      updatePrice();
      requestAnimationFrame(updateScrollHints);
    });
  });

  runSelectionInitTask('URL configuration', () => {
    BeltConfigURL.init(qs('#customizer'), {
      onSelected(field) {
        if (field === 'buckle') visitedSteps.add(1);
        if (field === 'size') visitedSteps.add(2);
      },
      onApplied() {
        updateInitialsState();
        initRecap();
        updatePrice();
        updateBundleSelection();
        requestAnimationFrame(updateScrollHints);
      }
    });
  });

  requestAnimationFrame(() => {
    runSelectionInitTask('navigation refresh', updateStepNavigationUI);
    runSelectionInitTask('hint refresh', updateScrollHints);
    refreshSelectionPrice();
  });
}

function scheduleBeltSelectionInit() {
  if (qs('#customizer')) initBeltSelection();
}

scheduleBeltSelectionInit();
document.addEventListener('DOMContentLoaded', scheduleBeltSelectionInit, { once: true });
window.addEventListener('load', scheduleBeltSelectionInit, { once: true });

function refreshSelectionPrice(attempt = 0) {
  try {
    if (updatePrice()) return;
  } catch (error) {
    console.warn('Initial belt price is not ready yet.', error);
  }
  if (attempt < 10) setTimeout(() => refreshSelectionPrice(attempt + 1), 100);
}

document.addEventListener('belt:initials-toggle', () => {
  updateInitialsState();
  updatePrice();
  updateBundleSelection();
});

requestAnimationFrame(() => refreshSelectionPrice());
